<h1 class="title-bar pcps-dialog-title sap-dialog-title">
    <span class="dialog-title">{{ title }}</span>
</h1>
<mat-dialog-content>
    <div class="flex flex-col items-stretch justify-start gap-2.5">
        <div class="dialog-message" [innerHTML]="message() | safeHTML"></div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="gap-3">
    <button type="button" class="cancelbtn sap-button" (click)="CancelHandler()">{{ canceltext }}</button>
    <button type="button" class="okbtn sap-button" (click)="OKHandler()" cdkFocusInitial>{{ oktext }}</button>
</mat-dialog-actions>
